module.exports = __webpack_public_path__ + "img/pr-1.688a68ec.png";